import { crossIconWhite, redStamp } from "../../images/general";
import React from "react";
import Modal from "./Modal";

const BioModal = ({
  isVisible,
  onClose,
}: {
  isVisible: boolean;
  onClose: any;
}) => {
  return (
    <Modal
      isVisible={isVisible}
      className="sm:max-w[880px] sm:w-[880px] w-[370px] bg-no-repeat bg-cover bg-center p-3  h-[680px] m-auto flex flex-col bg-[url('../images/general/BioModalBgMobile.png')] sm:bg-[url('../images/general/BioModalBg.png')]"
    >
      <div className="w-full h-16 bg-no-repeat bg-cover bg-center px-8 flex items-center justify-between bg-[url('../images/general/mobileModalHeader.png')] sm:bg-[url('../images/general/desktopModalHeader.png')]">
        <h1 className="text-white font-normal text-sm leading-6">Bio</h1>
        <span className="text-black text-xl cursor-pointer" onClick={onClose}>
          <img src={crossIconWhite} alt="" />
        </span>
      </div>
      <div className="sm:px-8 px-2 py-8 sm:pt-8 pt-20 relative">
        <h3 className="sm:text-[40px] text-[28px] font-cinzel text-white font-bold sm:leading-[40px] leading-7 sm:max-w-4xl sm:w-1/2 mb-3">
          Engin Altan Düzyatan
        </h3>
        <h3 className="sm:text-[24px] text-sm font-cinzel text-[#ACD6E9] font-bold sm:leading-8 leading-7 sm:max-w-4xl sm:w-[70%]">
          Producer, Turkish Film & Television Actor
        </h3>
        <img
          src={redStamp}
          className="absolute sm:-right-16 right-0 top-0 sm:w-auto w-[124px]"
          alt=""
        />
        <div className="h-80 overflow-y-auto mt-8 sm:w-[605px] custom-scroll">
          <div className="sm:w-[538px] ">
            <p className="text-[#E7E7E7] sm:text-base text-sm sm:leading-8 leading-7 font-normal">
            Engin Altan Düzyatan, the award-winning internationally acclaimed actor, is the face of Ertugrul in Medieval Empires. With a massively successful acting career and winning numerous prestigious awards, Engin is now leading the Kayi tribe in our game.
            </p>
            <p className="text-[#E7E7E7] sm:text-base text-sm sm:leading-8 leading-7 font-normal mt-7">
            With Altan’s association, Medieval Empires is set to become a game fitting of the legendary historical figure, Ertugrul, and the legacy associated with him. Players will get the true feel of reliving some of the most action-packed and iconic events in history, right through the eyes of Ertugrul himself!
has context menu
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BioModal;
